import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { LMSCourseEnrollment } from '@nsc/simple-lms/entities/LMSCourseEnrollment.js';
import { SmartTeamsFieldEngineer } from '@nsc/smartteams-shared/db/SmartTeamsFieldEngineer.js';
import { SmartTeamsPartnerCompany } from './SmartTeamsCompany.js';

// Extend the shared entity with backend-specific DataLoadedFields
DataLoadedField(
  () => [SmartTeamsPartnerCompany],
  ({ partnerCompanyIds }: SmartTeamsFieldEngineer) => partnerCompanyIds ?? [],
)(SmartTeamsFieldEngineer.prototype, 'partnerCompanies');
DataLoadedField(
  () => [LMSCourseEnrollment],
  ({ userId }: SmartTeamsFieldEngineer) => ({ userId }),
)(SmartTeamsFieldEngineer.prototype, 'enrollments');

// Type augmentation for the computed fields
declare module '@nsc/smartteams-shared/db/SmartTeamsFieldEngineer.js' {
  interface SmartTeamsFieldEngineer {
    partnerCompanies: Maybe<SmartTeamsPartnerCompany[]>;
    enrollments: Maybe<LMSCourseEnrollment[]>;
  }
}

export { SmartTeamsFieldEngineer } from '@nsc/smartteams-shared/db/SmartTeamsFieldEngineer.js';
